<ng-select *ngIf="!disable" [items]="companys" bindLabel="name" bindValue="id" [virtualScroll]="true" 
    placeholder="{{_placeholder}}" [(ngModel)]="companyId" (ngModelChange)="onChanged()" [selectOnTab]="true">
</ng-select>

<input *ngIf="disable" type="text" [(ngModel)]="companyName" style="width:100%"  class="form-control" [disabled]="true" />
